<forge-card [formGroup]="formGroup" telemetry="Card-TotalCommunityConsumptionChart-UtilityBilling" no-padding>
    <forge-toolbar fxLayout="column">
        <h2 slot="start" class="forge-typography--heading4">Total Community Consumption</h2>
        <lgd-select slot="center" controlName="serviceType" label="Service" [options]="serviceTypesObservable"
            [suppressSupportText]="true" style="width: 60%;">
        </lgd-select>
        <forge-icon-button slot="end" class="chart-settings" (click)="displayChartParameterDialogAndReload()"
            tabindex="0" aria-haspopup="true" telemetry="Chart settings" aria-label="chart settings">
            <forge-tooltip position="bottom">Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </forge-toolbar>

    <div class="metadata-padding">
        @if (isLoaded) {
        <div>
            @if (showChart()) {
            <chartjs-container [config]="chartConfig">
            </chartjs-container>
            }
            @if (!chartHasData) {
            <div>
                Not enough data to display graph
            </div>
            }
        </div>
        }
        @else {
        <busy-indicator [chart]="true"></busy-indicator>
        }
    </div>
</forge-card>